var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-tabs",
        {
          attrs: { name: "activeName2" },
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName2,
            callback: function($$v) {
              _vm.activeName2 = $$v
            },
            expression: "activeName2"
          }
        },
        [
          _c("el-tab-pane", { attrs: { label: "订单详情", name: "first" } }),
          _vm._v(" "),
          !_vm.contractClosed
            ? _c("el-tab-pane", {
                attrs: { label: "配货信息", name: "second" }
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.contractClosed
            ? _c("el-tab-pane", { attrs: { label: "收货单", name: "third" } })
            : _vm._e(),
          _vm._v(" "),
          !_vm.contractClosed
            ? _c("el-tab-pane", {
                attrs: { label: "订单操作记录", name: "fourth" }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.showFirst
        ? _c("swb-goods-order-info", {
            attrs: {
              name: "result_table",
              goodsOrderId: _vm.goodsOrderId,
              theTableHeight: _vm.theTableHeight
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showSecond
        ? _c("swb-order-goods-alloc-item-list", {
            attrs: {
              name: "result_table",
              theTableHeight: _vm.theTableHeight,
              selfPath: _vm.selfPath,
              goodsOrderId: _vm.goodsOrderId,
              manualAllocFlag: _vm.manualAllocFlag
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showThird
        ? _c("swb-goods-recv-voucher-list", {
            attrs: {
              name: "result_table",
              theTableHeight: _vm.theTableHeight,
              goodsOrderId: _vm.goodsOrderId
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showFourth
        ? _c("swb-goods-order-record-list", {
            attrs: {
              name: "result_table",
              theTableHeight: _vm.theTableHeight,
              goodsOrderId: _vm.goodsOrderId
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d94e885", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d94e885","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/order/ShowGoodsOrder.vue
// module id = 2966
// module chunks = 0